var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var tabStates = ['accounts.detail.contacts.accountContacts', 'accounts.detail.contacts.relatedContacts'];

var AccountContactsParentCtrl = function () {
    function AccountContactsParentCtrl($state, $scope) {
        var _this = this;

        _classCallCheck(this, AccountContactsParentCtrl);

        this._state = $state;
        this._setSelectedVars($state.current.name);
        $scope.$on('$stateChangeSuccess', function (event, toState) {
            _this._setSelectedVars(toState.name);
        });
    }

    _createClass(AccountContactsParentCtrl, [{
        key: 'selectTab',
        value: function selectTab(idx) {
            this._state.go(tabStates[idx]);
        }
    }, {
        key: '_setSelectedVars',
        value: function _setSelectedVars(stateName) {
            this.accountSelected = tabStates.indexOf(stateName) === 0;
            this.relatedSelected = tabStates.indexOf(stateName) === 1;
        }
    }]);

    return AccountContactsParentCtrl;
}();

AccountContactsParentCtrl.$inject = ['$state', '$scope'];

export default AccountContactsParentCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/controllers/AccountContactsParentCtrl.js
// module id = 1657
// module chunks = 0